import { SimMetricsGroupedMockData } from "../../mock";

export const getMockMetricDetails = (
  month: number,
) => {
  return {
    results: SimMetricsGroupedMockData.results.filter(
      (m) =>
        m.month === month
    ),
  };
};